import { render } from "./AgendamentosView.vue?vue&type=template&id=43693f41&scoped=true"
import script from "./AgendamentosView.vue?vue&type=script&lang=js"
export * from "./AgendamentosView.vue?vue&type=script&lang=js"

import "./AgendamentosView.vue?vue&type=style&index=0&id=43693f41&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43693f41"]])

export default __exports__